import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=12faf226&scoped=true"
import script from "./icons.ts?vue&type=script&lang=ts&external"
export * from "./icons.ts?vue&type=script&lang=ts&external"
import style0 from "./icons.vue?vue&type=style&index=0&id=12faf226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12faf226",
  null
  
)

export default component.exports